import { render, staticRenderFns } from "./CampaignNavigation.vue?vue&type=template&id=f28e7b04&scoped=true&"
import script from "./CampaignNavigation.vue?vue&type=script&lang=js&"
export * from "./CampaignNavigation.vue?vue&type=script&lang=js&"
import style0 from "./CampaignNavigation.vue?vue&type=style&index=0&id=f28e7b04&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28e7b04",
  null
  
)

export default component.exports